<div class="container">
  <h1 class="my-4">Development pages and Test sections</h1>
  <hr />
  <tabset type="pills">
    <tab heading="Pages in development">
      <div class="container-fluid container-shadow py-3 px-2">
        <p>
          <a routerLink="/matters">Matter Index</a>
        </p>
      </div>
    </tab>
    <tab heading="Action cable testing">
      <div class="container-fluid container-shadow py-3 px-2">
        <div class="form-group">
          <label>Channel Name</label>
          <input name='channel_name' ngDefaultControl [(ngModel)]="channelName" type="text" class="form-control" />
        </div>
        <div class="form-group">
          <label>Stream Name Identifier</label>
          <input name='channel_identifier' ngDefaultControl [(ngModel)]="channelIdentifier" type="text" class="form-control" />
        </div>
        <div class="form-group">
          <button (click)="connectToTestChannel()" type="button" class="btn btn-primary">Connect</button>
          &nbsp; Status:&nbsp;<app-badge badgeType="info">{{ channelStatus }}</app-badge>
        </div>
        <div class="form-group">
          <label>Send a message</label>
          <div class="input-group mb-3">
            <input name='message' ngDefaultControl type="text" class="form-control" placeholder="Message" [(ngModel)]="message" />
            <div class="input-group-append">
              <button class="btn btn-primary" (click)="sendMessage()" type="button">Send</button>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab heading="Error testing">
      <div class="container-fluid container-shadow py-3 px-2">
        <div class="form-group">
          <input name='error_text' ngDefaultControl type="text" class="form-control" placeholder="Error text" [(ngModel)]="errorText" (keyup.enter)="triggerError()" />
          <small class="text-muted form-text">Custom error message</small>
        </div>
        <div class="form-group text-center">
          <button type="button" class="btn btn-primary" (click)="triggerError()">Trigger error</button>
        </div>
      </div>
    </tab>
    <tab heading="Document by pages">
      <div class="container-fluid container-shadow py-3 px-2">
        <div class="form-group">
          <label>Id of document to download</label>
          <input type="text" class="form-control" name="document_id" ngDefaultControl placeholder="Id of document to get pages" [(ngModel)]="documentId" />
        </div>
        <div class="form-group">
          <label>Pages of document(print format)</label>
          <input type="text" class="form-control" name="pages" ngDefaultControl placeholder="Pages of document" [(ngModel)]="documentPages" />
          <small class="text-muted form-text">Pages in printer format, eg: 1-3,7,9</small>
        </div>
        <div class="form-group text-center">
          <a target="_blank" [href]="'/development/document_pages?document_id=' + documentId + '&pages=' + documentPages" class="btn btn-primary">View</a>
        </div>
      </div>
    </tab>
  </tabset>
</div>
